import { Link } from "@/components";
import type { ReactNode } from "react";
import { t } from "@/utils";
import { pathNames } from "@/lib/constants/pathNames.constants";

export type TCrumb = {
	text: string;
	url?: string;
};

function Crumb({ crumb }: { readonly crumb: TCrumb }) {
	let component: string | ReactNode = crumb.text;

	if (crumb.url) {
		component = (
			<Link
				href={crumb.url}
				className="c-system-primary hover:underline"
				data-testid="breadcrumb-link"
			>
				{crumb.text}
			</Link>
		);
	}

	return (
		<li
			className="hmc-body-s px-2 text-contentSubtle"
			data-testid="breadcrumb-text"
		>
			{component}
		</li>
	);
}

const homeCrumb: TCrumb = { text: t("breadcrumb.home"), url: pathNames.home };

export default function Breadcrumb({ crumbs }: { readonly crumbs?: TCrumb[] }) {
	return (
		<ul
			className="ml-[-8px] flex list-none items-center pb-1"
			data-testid="breadcrumb"
		>
			{[homeCrumb]
				.concat(crumbs ?? [])
				.map<ReactNode>((crumb: TCrumb) => (
					<Crumb key={crumb.text} crumb={crumb} />
				))
				.reduce((prev, current, index) => [
					prev,
					// eslint-disable-next-line react/no-array-index-key
					<li key={index}>/</li>,
					current,
				])}
		</ul>
	);
}
